import { useCallback, useEffect, useState } from 'react';
import { STATES_COLLECTION_NAME } from '../../../../../constants/dealerLocator.constants';
import { fetchDataFromFirebaseDB } from '../../../dealerLocator.utils';
import {
  SearchType,
  TAreaPolygonData,
  TStatesFirebaseCollectionResponse,
  TUseRegionBordersCoordsProps,
} from '../../../types/dealerLocatorLanding.types';
import useFirebase from './useFirebase.effect';

const useRegionBordersCoords = ({ model, country }: TUseRegionBordersCoordsProps): Array<TAreaPolygonData> => {
  const [countriesPolygonData, setCountriesPolygonData] = useState<Array<TAreaPolygonData>>([]);
  const { app, firebase } = useFirebase();

  const processResponseData = useCallback(
    (data: TStatesFirebaseCollectionResponse): Array<TAreaPolygonData> => {
      const allowedStatesCodes = new Set(country?.states?.map((state) => state.gmiCode));
      const filteredData = data.filter((state) => allowedStatesCodes.has(state.GMI_ADMIN));
      const regionsNamesMap = new Map(country?.states?.map((state) => [state.gmiCode, state.name]));
      const regionPolygons = filteredData?.map((c) => {
        const polygonData: TAreaPolygonData = {
          kml: JSON.parse(c?.geometry),
          name: regionsNamesMap.get(c?.GMI_ADMIN) ?? '',
          code: c?.GMI_ADMIN,
        };

        return polygonData;
      });

      return regionPolygons;
    },
    [country, model]
  );

  useEffect(() => {
    if (!app || !firebase || !model.hasInteractiveMap || !country || model.searchType !== SearchType.SearchByCountryAndRegion) {
      return;
    }

    const queryParams = {
      fieldPath: 'FIPS_CNTRY',
      opStr: '==',
      value: country.fipsCode,
    };

    fetchDataFromFirebaseDB({ app, firebase, collectionName: STATES_COLLECTION_NAME, queryParams })
      .then((data) => {
        setCountriesPolygonData(processResponseData(data));
      })
      .catch((err) => {
        console.error('Error: Unable to fetch Country borders data', err);
        setCountriesPolygonData([]);
      });
  }, [app, firebase, !model.hasInteractiveMap, country]);

  return countriesPolygonData;
};

export default useRegionBordersCoords;
